























import { Vue, Component, Ref, Model, Prop } from "vue-property-decorator";
import DefinitionValue from "@/models/definitionValue";
import { Form } from "@/models/general";
import { cloneDeep } from "lodash";

@Component
export default class DefinitionValueForm extends Vue {
  @Model("change") value!: DefinitionValue;
  @Ref("form") readonly form!: Form;
  @Prop({ default: "create" }) readonly mode!: "edit";

  model: DefinitionValue = new DefinitionValue();

  created(): void {
    if (this.value) this.model = cloneDeep(this.value);
  }

  validate(): boolean {
    return this.form.validate();
  }

  reset(): void {
    this.form.reset();
  }

  updateModel(): void {
    this.$emit("change", this.model);
  }
}
